import Vue from 'vue';
import _ from 'lodash';
import inputLimiter from './directive/inputLimiter';

// 防抖指令
Vue.directive('debounce', {
  inserted: function (el, binding) {
    // 检查 binding.value 是否是函数
    if (typeof binding.value !== 'function') {
      console.warn('v-debounce: Expected a function, but got', typeof binding.value);
      return;
    }
    el.addEventListener('click', _.debounce(binding.value, 300));
  },
});

// 输入限制指令
Vue.directive('input-limiter', inputLimiter);
